import { useState } from 'react';
import { Link } from 'react-router';

import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as yup from 'yup';

import { api, useAPIContext } from '../../../../api/context';
import Icon from '../../../../components/Icon';
import { Title } from '../../../../utils/title';
import toast from '../../../../utils/toast';
import Layout from '../Layout';
import styles from './Password.module.scss';

const Password = () => {

  const [ loading, setLoading ] = useState(false);

  const { token } = useAPIContext();

  return (
    <>
      <Title value='Password - Profile' />
      <Layout>
        <div className={styles.root}>
          <div className={styles.content}>
            <div className={styles.header}>
              <Link
                to='/profile'
                aria-label='go back'>

                <Icon name={'arrow_back'} />

              </Link>

              <h1>Change Password</h1>
            </div>

            <Formik
              initialValues={{
                password_old: '',
                password_new_1: '',
                password_new_2: '',
              }}
              validationSchema={yup.object({
                password_old: yup.string()
                  .required('Required'),
                password_new_1: yup.string()
                  .required('Required'),
                password_new_2: yup.string()
                  .required('Required')
                  .oneOf([yup.ref('password_new_1'), null], 'Passwords must match'),
              })}
              onSubmit={(values, actions) => {

                if (loading) {
                  return;
                }

                setLoading(true);

                api(token).v1.auth.password
                  .post({
                    password_old: values.password_old,
                    password_new: values.password_new_1,
                  })
                  .then(res => {
                    setLoading(false);

                    if (res.status === 200) {
                      toast.show(toast.KIND.SUCCESS, 'Password changed.');
                    }

                    if (res.status === 400) {
                      toast.show(toast.KIND.ERROR, res.body);
                    }
                  })
                  .catch(err => {
                    setLoading(false);
                    toast.show(toast.KIND.ERROR, err);
                  });

              }} >

              <Form>
                <div>
                  <label htmlFor='password_old'>Current Password</label>
                  <Field
                    id='password_old'
                    aria-label='current password'
                    name='password_old'
                    type='password'
                    disabled={loading}
                  />
                  <ErrorMessage
                    name='password_old'
                    component='div'
                  />
                </div>

                <div>
                  <label htmlFor='password_new_1'>New Password</label>
                  <Field
                    id='password_new_1'
                    aria-label='new password'
                    name='password_new_1'
                    type='password'
                    disabled={loading}
                  />
                  <ErrorMessage
                    name='password_new_1'
                    component='div'
                  />
                </div>

                <div>
                  <label htmlFor='password_new_2'>Confirm Password</label>
                  <Field
                    id='password_new_2'
                    aria-label='confirm password'
                    name='password_new_2'
                    type='password'
                    disabled={loading}
                  />
                  <ErrorMessage
                    name='password_new_2'
                    component='div'
                  />
                </div>

                <button
                  type='submit'
                  disabled={loading}>

                  Save

                </button>
              </Form>

            </Formik>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Password;